import React from 'react'
import PropTypes from 'prop-types'
import '@fil-global/gds-webcomponents/fil-text-input/fil-text-input.component'

import './style.scss'

// Reference: http://design-fidelity-gds-prod.fil.aldryn.io/components/text-input/#develop
const Input = ({ onChange, onKeyup, onBlur, ...restProps }) => {
  const ref = React.useRef()

  React.useLayoutEffect(() => {
    const { current } = ref

    const handleChange = (customEvent) => onChange(customEvent.detail)
    current.addEventListener('onchange', handleChange)

    const handleKeyup = (customEvent) => onKeyup(customEvent.detail)
    current.addEventListener('onkeyup', handleKeyup)

    const handleBlur = (customEvent) => onBlur(customEvent.detail)
    current.addEventListener('onblur', handleBlur)

    return () => {
      current.removeEventListener('onchange', handleChange)
      current.removeEventListener('onkeyup', handleKeyup)
      current.removeEventListener('onblur', handleBlur)
    }
  }, [ref])

  return <fil-text-input ref={ref} {...restProps} />
}

Input.propTypes = {
  onChange: PropTypes.func,
  onKeyup: PropTypes.func,
  onBlur: PropTypes.func
}

Input.defaultProps = {
  onChange: () => {},
  onKeyup: () => {},
  onBlur: () => {}
}

export default Input
